import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ThfCodeEditorComponent } from './thf-code-editor.component';
import { ThfCodeEditorRegister } from './thf-code-editor-register.service';
import { ThfCodeEditorRegisterable } from './interfaces/thf-code-editor-registerable.interface';

/**
 * @description
 *
 * MÃ³dulo do componente thf-code-editor.
 */
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ThfCodeEditorComponent
  ],
  exports: [
    ThfCodeEditorComponent
  ],
  providers: [
    ThfCodeEditorRegister
  ]
})
export class ThfCodeEditorModule {

  static forRegister(props: ThfCodeEditorRegisterable): ModuleWithProviders {
    return {
      ngModule: ThfCodeEditorModule,
      providers: [
        {
          provide: ThfCodeEditorRegister,
          useValue: props
        }
      ]
    };
  }

}
